import styled from 'styled-components'
import theme from 'theme_'

export const AnalyticsFrame = styled.div`
  /* Frame 4 */

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 2px;

  width: 230px;
  height: fit-content;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;

  @media ${theme.devices.mobile} {
    width: 100%;
  }
`

export const AnalyticsListText = styled.span`
  width: fit-content;
  height: 12px;
  max-width: 220px;
  font-style: normal;
  font-weight: 450;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height */
  text-align: center;
  gap: 8px;

  color: ${theme.colors.otterWarmBlack};

  flex: none;
  order: 0;
  flex-grow: 0;
`
